import { Inject, Injectable, InjectionToken, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { AuthService } from './auth.service';

export interface UserProfileKc {
  sub: string;
  email_verified: boolean;
  realm_access: {roles: string[]};
  name: string;
  preferred_username: string;
  given_name: string;
  ownerId: string;
  family_name: string;
  // email: string; // Email is not used for now
}

export interface LoggedUserDetailService<User, Owner> {
  loggedUserDetail(): Observable<User>;
  loggedUserOwnerDetail(): Observable<Owner>;
}

export const LOGGED_USER_DETAIL_SVC: InjectionToken<string> = new InjectionToken("LOGGED_USER_SVC")

@Injectable()
export class AuthUserService<User, Owner> implements OnDestroy {
  private readonly _unSubscriber: Subject<any> = new Subject<any>();

  private readonly _userProfile: BehaviorSubject<UserProfileKc | null> = new BehaviorSubject<UserProfileKc | null>(null);
  public readonly userProfile$: Observable<UserProfileKc | null> = this._userProfile.asObservable();

  private readonly _userDetail: BehaviorSubject<User | null> = new BehaviorSubject<User | null>(null);
  public readonly userDetail$: Observable<User | null> = this._userDetail.asObservable();

  private readonly _ownerDetail: BehaviorSubject<Owner | null> = new BehaviorSubject<Owner | null>(null);
  public readonly ownerDetail$: Observable<Owner | null> = this._ownerDetail.asObservable();

  private readonly _isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isAuthenticated$: Observable<boolean> = this._isAuthenticated.asObservable();

  constructor(private readonly _authSvc: AuthService, @Inject(LOGGED_USER_DETAIL_SVC) private readonly _loggedUserSvc: LoggedUserDetailService<User, Owner>) {
    _authSvc.isAuthenticated$.pipe(takeUntil(this._unSubscriber)).subscribe(val => {
      if (val != this._isAuthenticated.value) {
        this._isAuthenticated.next(val);
      }
    });
  }

  ngOnDestroy() {
    this._unSubscriber.next(null);
    this._unSubscriber.unsubscribe();
  }

  public reloadProfile(): void {
    this._getUserProfile();
  }

  public reloadLoggedUser(): void {
    this._getLoggedUser();
  }

  public reloadLoggedUserMachineOwner(): void {
    this._getLoggedUserMachineOwner();
  }

  private _getUserProfile(): void {
    this._authSvc.userProfile
      .then((p: any) => {
        this._userProfile.next(p.info as UserProfileKc);
      });
  }

  private _getLoggedUser(): void {
    if(this._loggedUserSvc) {
      this._loggedUserSvc.loggedUserDetail().pipe(takeUntil(this._unSubscriber)).subscribe(value => {
        this._userDetail.next(value);
      });
    }
  }

  private _getLoggedUserMachineOwner(): void {
    if (this._loggedUserSvc) {
      this._loggedUserSvc.loggedUserOwnerDetail().pipe(takeUntil(this._unSubscriber)).subscribe(value => {
        this._ownerDetail.next(value);
      });
    }
  }

}
